//import from node modules
import React from 'react'
import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

//import utility functions
import {openLiveChat} from "../../../../utilities/function/common"
import {getAppConfigValue,getAttributes} from "../../../../utilities/function/configuration"

let SwitchFinished = (props) => {
  const {data} = props
  if(getAttributes(data)){
    const { first_name , email } = getAttributes(data)
    const complete_icon = getAppConfigValue('complete_icon')
    const company_phone = getAppConfigValue('complete_icon')
    const company_email = getAppConfigValue('complete_email')
    return (<div className={'of-switch-finished'}>
      <div className={'of-switch-finished__container of-checkout-content'}>
        <div className={'of-finished-header'}>
          <img className={'of-finished-header__image'} src={complete_icon} alt={"Complete"}/>
          <div className={'of-finished-header__heading text-font-1-100'}>Thanks {first_name}!<br/>We received your request to SWITCH!</div>
        </div>
        <div className={'of-finished-description'}>
          <div className={'of-finished-description__item'}>
            <div className={'of-finished-description__title text-font-2-100'}>What happens next?</div>
            <div className={'of-finished-description__text text-font-3-100'}>
              Our Solutions team is currently reviewing your request to Switch. We endeavour to process your request as soon as possible. A confirmation email has been sent to <a className={`primary-font-1-100`} href={`mailto:${email}`}>{email}</a>. If you haven't received your confirmation email within a few minutes, please check your spam or junk folder.
            </div>
          </div>
          <div className={'of-finished-description__item'}>
            <div className={'of-finished-description__text text-font-3-100'}>
              {`If you'd like to expedite the review process, you’re welcome to contact us via `}
              <a href={`mailto:${company_email}`} className={'of-switch-finished__link primary-font-1-100'}>Email</a>, <button onClick={openLiveChat} className={'of-switch-finished__link of-button-link primary-font-1-100'}>Live Chat</button> or <a href={`tel:${company_phone}`} className={'of-switch-finished__link primary-font-1-100'}>Phone</a>.
            </div>
          </div>
        </div>
      </div>
    </div>);
  }
  return (<></>)
}

SwitchFinished.propTypes = {
  data: PropTypes.object
}

SwitchFinished = withRouter(SwitchFinished)


export default SwitchFinished